import { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  filter,
  deleteFilter,
  filterAndKeepAll,
  clearAllFilters,
} from "../../actions/products-actions/actions";
import { Filter } from "../../components/Filter/Filter";
import { Link } from "react-router-dom";
import { handleLeftDrawer, handleBottomDrawer } from "../../actions/actionCreators";
import { Drawer, Skeleton, Card, message, Divider, Tooltip } from "antd";
import Select from "antd/lib/select";
import { useParams, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { getCollaborators } from "../../actions/order-actions/actions";
import "./CollectionProducts.scss";
import { FilterOutlined, ClearOutlined, PlusOutlined } from "@ant-design/icons";
import { Spinner } from "../../components/Spinner";
import backArrow from "../../img/backArrow.png";
import { history } from "../../index";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { addProducttoFolder, createFolder } from "../../actions/folders-actions/actions";
import { StandardDraggableProductCard } from "../ProductCard/StandardDraggableProductCard";
import ExampleProductCard from "../ProductCard/ExampleProductCard";
import placeholder_jeans from "../../img/placeholder_jeans.svg";
import axiosInstance from "../../config/axios-instance";
import { v4 as uuidv4 } from "uuid";
import ProductServices from "../../actions/products-actions/services";
import DenimProduct from "../ProductDetails/DenimProduct";
import KnitProduct from "../ProductDetails/KnitProduct";
import MixProduct from "../ProductDetails/MixProduct";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import Folder from "../Folder/Folder";
import PlusIcon from "../../icons/PlusIcon";
import { clearfolderToMoveTo } from "../../actions/folders-actions/actions";
import "../AddToCollection/AddToCollection.scss";
import { Button as DemcoButton } from "../Button/Button";

const { Meta } = Card;

interface Props {}

interface ProductData {
  id: number;
  name: string;
  fabric_type: string;
  price: number;
  images: Array<{image: string}>;
  is_out?: boolean;
  [key: string]: any;
}

interface PaginationData {
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
}

export const CollectionProducts = (props: Props) => {
  const location = useLocation();
  const params: any = useParams();
  
  // Filter States
  const [min_price_allowed, setMin_price_allowed] = useState(0);
  const [max_price_allowed, setMax_price_allowed] = useState(1000);
  const [min_price, setMin_price] = useState(0);
  const [max_price, setMax_price] = useState(1000);
  const [min_priceBefore, setMin_priceBefore] = useState(1);
  const [max_priceBefore, setMax_priceBefore] = useState(1000);
  
  const [min_elasticity, setMin_elasticity] = useState(0);
  const [max_elasticity, setMax_elasticity] = useState(100);
  const [min_elasticity_before, setMin_elasticity_before] = useState(0);
  const [max_elasticity_before, setMax_elasticity_before] = useState(100);

  const [min_weight, setMin_weight] = useState(0);
  const [max_weight, setMax_weight] = useState(100);
  const [min_weight_before, setMin_weight_before] = useState(0);
  const [max_weight_before, setMax_weight_before] = useState(100);

  const [forYouCompany, setForYouCompany] = useState<any>(null);
  const [company, setCompanies] = useState<any>(null);
  const [clients, setClients] = useState<any>(null);

  const [count, setcount] = useState(0);
  const [queries, setQueries] = useState<Array<string>>([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  
  const [url, setUrl] = useState(
    `/products?collections=${params.collectionId}&fabric_types=${params.fabric}`
  );


  const {
    productsAll,
    filters,
    prices,
  } = useSelector((state: any) => state.products);

  // New Fetching Logic State matches Products.tsx
  const [dataToMap, setDataToMap] = useState<ProductData[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState<PaginationData>({
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: 30
  });

  const dispatch = useDispatch();

  const [quickViewProduct, setQuickViewProduct] = useState<any>(null);
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [showCollectionForm, setShowCollectionForm] = useState(false);

  const [folderData, setFolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season: '',
    year: ""
  });

  const { collaborators } = useSelector((state: any) => state.orders);

  const customStylesCreate = {
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      boxShadow: "none",
      "&:hover": {
        outline: "none",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
    }),
  };

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#00468c",
      },
    }),
  };

  const currentYear = new Date().getFullYear();
  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];

  const handleCreateNewFolder = () => {
    if (!folderData.name) {
      message.error("Please specify the collection name!");
      return;
    }
    dispatch(createFolder({ ...folderData, product_id: quickViewProduct?.id }));
    setShowCollectionForm(false);
    setFolderData({ name: "", description: "", collaborator: [], season: '', year: "" });
    message.success("Collection created successfully");
  };

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, [dispatch]);
  const folders = useSelector((state: any) => state.folders);
  const { user } = useSelector((state: any) => state.auth);

  const openQuickView = async (product: any) => {
    setQuickViewProduct(product);
    setQuickViewVisible(true);
    
    // Fetch full details
    try {
        const response = await ProductServices.getOneProduct(product.id);
        const fullProduct = response.data || response;
        setQuickViewProduct(fullProduct);
    } catch (error) {
        console.error("Error fetching full product details", error);
    }
  };

  // Observer for infinite scroll
  const observer = useRef<IntersectionObserver | null>(null);
  const lastProductElementRef = useCallback((node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setCurrentPage(prevPage => prevPage + 1);
      }
    });
    
    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

  // Initial Data Load (Companies, Clients, Filter Metadata)
  useEffect(() => {
    const initializeData = async () => {
      let token = localStorage.getItem("token");
      const company_id = localStorage.getItem("company_id");

      axiosInstance({
        method: "get",
        url: `/admin/companies`,
        headers: { Authorization: `Bearer ${token}` },
      }).then((res) => setCompanies(res.data));

      axiosInstance({
        method: "get",
        url: `/clients/for_you`,
        headers: { Authorization: `Bearer ${token}` },
      }).then((res) => setClients(res.data));

      if (company_id) {
        axiosInstance({
          method: "get",
          url: `/admin/forYouCompany/${company_id}`,
          headers: { Authorization: `Bearer ${token}` },
        }).then((res) => setForYouCompany(res.data));
      }
    };
    initializeData();
  }, []);

  // Window Resize
  useEffect(() => {
    let resize = () =>
      window.addEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    resize();
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  // Location Change -> Init Filters
  useEffect(() => {
    dispatch(
      filterAndKeepAll(
        `/products?collections=${params.collectionId}&fabric_types=${params.fabric}`
      )
    );
     // Reset queries if needed or keep them? Products.tsx resets them.
     // setQueries([]);
  }, [location.pathname, params.collectionId, params.fabric]);

  // Sync Max/Min Prices from Redux
  useEffect(() => {
    setMax_price(prices.max_price);
    setMin_price(prices.min_price);
    setMax_price_allowed(prices.max_price);
    setMin_price_allowed(prices.min_price);
    setMin_priceBefore(prices.min_price);
    setMax_priceBefore(prices.max_price);
  }, [productsAll]);


  // Main Fetch Effect (Filter Change)
  useEffect(() => {
     setDataToMap([]);
     setCurrentPage(1);
     setHasMore(true);
     fetchProducts(1, true);
     dispatch(addFilter(queries));
  }, [
    min_price, 
    max_price, 
    queries, 
    min_elasticity, 
    max_elasticity, 
    min_weight, 
    max_weight, 
    // params.collectionId, 
    // params.fabric
  ]);

  // Pagination Effect
  useEffect(() => {
    if (currentPage > 1) {
      fetchProducts(currentPage, false);
    }
  }, [currentPage]);


  const fetchProducts = (page: number, reset: boolean = false) => {
    setLoading(true);
    let token = localStorage.getItem("token");
    
    // Construct Params
    const paramsObj: { [key: string]: string | number } = {
      page,
      limit: 30,
      collections: params.collectionId,
      fabric_types: params.fabric,
    };

     // Parse queries array
    queries.forEach(q => {
        const [key, val] = q.split("=");
        if(key && val) paramsObj[key] = val;
    });

    if (min_price !== undefined) paramsObj.min_price = min_price;
    if (max_price !== undefined) paramsObj.max_price = max_price;
    
    if (params.fabric === "denim") {
       if (min_elasticity !== undefined) paramsObj.elasticity_min = min_elasticity;
       if (max_elasticity !== undefined) paramsObj.elasticity_max = max_elasticity;
       if (min_weight !== undefined) paramsObj.weight_min = min_weight;
       if (max_weight !== undefined) paramsObj.weight_max = max_weight;
    }

    axiosInstance({
      method: "get",
      url: '/products',
      params: paramsObj,
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      const { data, current_page, last_page, total, per_page } = response.data;
      
      if (data && data.length > 0) {
        if (reset) {
          setDataToMap(data);
        } else {
          setDataToMap(prev => [...prev, ...data]);
        }
        
        setPaginationData({
          current_page,
          last_page,
          total,
          per_page
        });
        
        setHasMore(current_page < last_page);
      } else {
        if (reset) setDataToMap([]);
        setHasMore(false);
      }
      setLoading(false);
    }).catch(err => {
      console.error("Fetch collection products error", err);
      setLoading(false);
    });
  };

  const handleChangeWeight = (val: any) => {
    let [min, max] = val;
    setMin_weight(min);
    setMax_weight(max);
  };

  const handleChangePrice = (val: any) => {
    let [min, max] = val;
    setMin_price(min);
    setMax_price(max);
  };

  const handleChangePriceAfter = (val: any) => {
    let [min, max] = val;
    setMin_priceBefore(min);
    setMax_priceBefore(max);
  };

  const handleChangeElasticity = (val: any) => {
    let [min, max] = val;
    setMin_elasticity(min);
    setMax_elasticity(max);
  };

  const addQuery = (target: any) => {
    const element = target.name + "=" + target.id;
    if (target.checked) {
      var exists = queries.filter((query: any) => query.includes(target.name));
      if (exists.length === 0) {
        setQueries([...queries, element]);
      } else {
        var newQueryVal = exists[0].concat("," + target.id);
        setQueries(
          queries.map((el: any) =>
            el.includes(target.name) ? newQueryVal : el
          )
        );
      }
    } else if (!target.checked) {
      var exist = queries.filter((query: any) =>
        query.includes(target.name)
      )[0];
      if (exist.includes(",") === false) {
        setQueries(queries.filter((el) => !el.includes(target.name)));
      } else if (
        exist.indexOf(target.id) ===
        exist.length - target.id.toString().length
      ) {
        let newQuery = exist.substr(
          0,
          exist.length - (target.id.toString().length + 1)
        );
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      } else {
        let newQuery = exist.replace(target.id + ",", "");
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      }
    }
  };

  const deleteFilterTag = (obj: any) => {
    var exist = queries.filter((query: any) =>
      query.includes(obj.filteredBy)
    )[0];
    if (exist.includes(",") === false) {
      setQueries(queries.filter((el) => !el.includes(obj.filteredBy)));
    } else if (
      exist.indexOf(obj.id) ===
      exist.length - obj.id.toString().length
    ) {
      let newQuery = exist.substr(
        0,
        exist.length - (obj.id.toString().length + 1)
      );
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    } else {
      let newQuery = exist.replace(obj.id + ",", "");
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    }
  };

  const onDragEnd = useCallback((draggable: any) => {
    const { destination, draggableId } = draggable;

    if (draggableId) {
      if (draggableId.includes("draggable-product")) {
        const productData = JSON.parse(draggableId);

        const productId = productData.draggableId.substring(
          "draggable-product".length
        );
        const currentproductParentId = productData.parentId;
        if (destination && destination.droppableId) {
          if (destination.droppableId.includes("droppable-minature")) {
            const newParentIdDroppable = destination.droppableId.substring(
              "droppable-minature".length
            );
            if (newParentIdDroppable !== currentproductParentId) {
              dispatch(addProducttoFolder(newParentIdDroppable, productId));
              setIsDragging(false);
            }
          }
        }
      }
    }
    setIsDragging(false);
  }, [dispatch]);
  
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const onDragStart = () => {
    setIsDragging(true);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <div className="products_page_container_product">
        <div className={`container-fluid products_page`}>
          {width >= 1000 && (
            <div className="filter_collection">
              <Filter
                setMax_elasticity_before={setMax_elasticity_before}
                setMin_elasticity_before={setMin_elasticity_before}
                max_elasticity_before={max_elasticity_before}
                min_elasticity_before={min_elasticity_before}
                isDragging={isDragging}
                fabric=""
                categoryId=""
                genderId=""
                handleChangePrice={handleChangePrice}
                min_price={min_price}
                max_price={max_price}
                urlProp={url}
                setUrl={setUrl}
                queries={queries}
                addQuery={addQuery}
                min_price_allowed={min_price_allowed}
                max_price_allowed={max_price_allowed}
                setMax_price={setMax_price}
                setMin_price={setMin_price}
                setMax_price_allowed={setMax_price_allowed}
                setMin_price_allowed={setMin_price_allowed}
                handleChangePriceAfter={handleChangePriceAfter}
                max_priceBefore={max_priceBefore}
                min_priceBefore={min_priceBefore}
                max_elasticity={max_elasticity}
                min_elasticity={min_elasticity}
                handleChangeElasticity={handleChangeElasticity}
                setMax_weight_before={setMax_weight_before}
                setMin_weight_before={setMin_weight_before}
                max_weight_before={max_weight_before}
                min_weight_before={min_weight_before}
                max_weight={max_weight}
                min_weight={min_weight}
                handleChangeWeight={handleChangeWeight}
              />
            </div>
          )}
          <div className="products_list_collection">
            <div className="filter_tags_wrapper">
              <div style={{ width: "90%" }}>
                {width >= 1000 ? (
                  ((filters && filters.length > 0) ||
                    max_price_allowed !== max_price ||
                    min_price_allowed !== min_price ||
                    max_elasticity !== 100 ||
                    min_elasticity !== 0) && <p>Selected Filters:</p>
                ) : (
                  <button
                    className="filter_product_button"
                    onClick={() => setOpenFilterDrawer(true)}
                  >
                    <FilterOutlined className="mr-2" /> Filter
                  </button>
                )}
                <Drawer
                  title="FILTER"
                  placement={"left"}
                  closable={true}
                  onClose={() => setOpenFilterDrawer(false)}
                  visible={openFilterDrawer}
                  key={"left"}
                >
                  <div className="p-3">
                    <Filter
                      setMax_elasticity_before={setMax_elasticity_before}
                      setMin_elasticity_before={setMin_elasticity_before}
                      max_elasticity_before={max_elasticity_before}
                      min_elasticity_before={min_elasticity_before}
                      isDragging={isDragging}
                      fabric={params.fabric}
                      categoryId={params.categoryId}
                      genderId={params.genderId}
                      handleChangePrice={handleChangePrice}
                      min_price={min_price}
                      max_price={max_price}
                      urlProp={url}
                      setUrl={setUrl}
                      queries={queries}
                      addQuery={addQuery}
                      min_price_allowed={min_price_allowed}
                      max_price_allowed={max_price_allowed}
                      setMax_price={setMax_price}
                      setMin_price={setMin_price}
                      setMax_price_allowed={setMax_price_allowed}
                      setMin_price_allowed={setMin_price_allowed}
                      handleChangePriceAfter={handleChangePriceAfter}
                      max_priceBefore={max_priceBefore}
                      min_priceBefore={min_priceBefore}
                      max_elasticity={max_elasticity}
                      min_elasticity={min_elasticity}
                      handleChangeElasticity={handleChangeElasticity}
                      setMax_weight_before={setMax_weight_before}
                      setMin_weight_before={setMin_weight_before}
                      max_weight_before={max_weight_before}
                      min_weight_before={min_weight_before}
                      max_weight={max_weight}
                      min_weight={min_weight}
                      handleChangeWeight={handleChangeWeight}
                    />
                  </div>
                </Drawer>
                <div className="filter_tags">
                  {((filters && filters.length > 0) ||
                    max_price_allowed !== max_price ||
                    min_price_allowed !== min_price ||
                    max_elasticity !== 100 ||
                    min_elasticity !== 0) && (
                    <div
                      className="filter_tag"
                      onClick={() => {
                        setMax_price(prices.max_price);
                        setMin_price(prices.min_price);
                        setMin_priceBefore(prices.min_price);
                        setMax_priceBefore(prices.max_price);
                        setMax_elasticity(100);
                        setMin_elasticity(0);
                        setMax_elasticity_before(100);
                        setMin_elasticity_before(0);
                        dispatch(clearAllFilters());
                        setQueries([]);
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "rgba(255, 0, 69, 0.1)",
                        border: "2px solid rgba(255, 0, 69, 0.4)",
                        boxSizing: "border-box",
                        padding: "8px 13px",
                      }}
                    >
                      <p>Clear filters</p>
                      <span>
                        <ClearOutlined
                          style={{ transform: "translateY(-3px)" }}
                        />
                      </span>
                    </div>
                  )}
                  {(max_price_allowed !== max_price ||
                    min_price_allowed !== min_price) && (
                    <div className="filter_tag">
                      <p>{`${min_price} - ${max_price}`}</p>
                      <span
                        onClick={() => {
                          setMax_price(prices.max_price);
                          setMin_price(prices.min_price);
                          setMin_priceBefore(prices.min_price);
                          setMax_priceBefore(prices.max_price);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {(max_elasticity !== 100 || min_elasticity !== 0) && (
                    <div className="filter_tag">
                      <p>{`${min_elasticity} - ${max_elasticity}`}</p>
                      <span
                        onClick={() => {
                          setMax_elasticity(100);
                          setMin_elasticity(0);
                          setMax_elasticity_before(100);
                          setMin_elasticity_before(0);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {filters &&
                    filters.map((el: any, i: number) => (
                      <div className="filter_tag" key={i}>
                        <p>{el.name}</p>
                        <span
                          onClick={() => {
                            deleteFilterTag(el);
                            dispatch(deleteFilter(el.name));
                          }}
                        >
                          X
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {loading && currentPage === 1 ? (
              <div className="row ">
                {Array.from({ length: 10 }, (_, index) => index + 1).map(
                  (_, i) => (
                    <div className="col-12 col-md-2" key={i}>
                      <div className="d-flex flex-column">
                        <Card
                          loading={true}
                          bordered={false}
                          style={{ width: "100%" }}
                          bodyStyle={{ padding: "5px" }}
                          cover={
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              src={placeholder_jeans}
                            />
                          }
                        >
                          <Meta title={"Code"} description={"Name"} />
                        </Card>
                      </div>
                    </div>
                  )
                )}{" "}
              </div>
            ) : dataToMap && dataToMap.length > 0 ? (
              <>
              <Droppable
                droppableId={`products-list-droppable`}
                direction="horizontal"
              >
                {(provided, snapshot) => (
                    <div
                      className="products-grid"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {dataToMap
                        .map((product: any, index: number) => {
                          if (dataToMap.length === index + 1) {
                            return (
                                <div ref={lastProductElementRef} key={`prod-col-container-${product.id}`}>
                                    <ExampleProductCard
                                        key={index}
                                        index={index}
                                        productPage={true}
                                        foryou={forYouCompany}
                                        company={company}
                                        clients={clients}
                                        product={product}
                                        onClick={() => openQuickView(product)}
                                        item={{
                                        main: product.images[0]
                                            ? product.images[0].path
                                            : "",
                                        onHover: product.images[1]
                                            ? product.images[1].path
                                            : "",
                                        }}
                                    />
                                </div>
                            )
                          } else {
                            return (
                                <ExampleProductCard
                                    key={index}
                                    index={index}
                                    productPage={true}
                                    foryou={forYouCompany}
                                    company={company}
                                    clients={clients}
                                    product={product}
                                    onClick={() => openQuickView(product)}
                                    item={{
                                    main: product.images[0]
                                        ? product.images[0].path
                                        : "",
                                    onHover: product.images[1]
                                        ? product.images[1].path
                                        : "",
                                    }}
                                />
                            )
                          }
                        })}
                        {provided.placeholder}
                    </div>
                )}
              </Droppable>
              {loading && currentPage > 1 && (
                  <div className="text-center py-4 w-100">
                    <Spinner />
                  </div>
              )}
              {!hasMore && dataToMap.length > 0 && (
                   <div className="text-center py-4 w-100">
                      No more products
                   </div>
              )}
              </>
            ) : (
              <div className="unavailable_products_container">
                <h3 className="unavailable_products">
                  No products available with the selected filters !
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
      
       <Drawer
              title="Product Details"
              placement={width > 768 ? "right" : "bottom"} // Bottom drawer on mobile fits better usually, or full width right
              width={width > 768 ? 720 : "100%"}
              height={width > 768 ? "100%" : "85vh"} // If placement is bottom
              onClose={() => setQuickViewVisible(false)}
              visible={quickViewVisible}
              bodyStyle={{ padding: 0 }}
            >
              {quickViewProduct && (
                <div className="product_details_contanier" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <div className="product_details_infos_scroll" style={{ border: "none", flex: 1, overflowY: "auto" }}>
                    <div className="product_details_infos" style={{ height: "auto", overflow: "visible" }}>
                            <div className="component_details">
                     
                      {quickViewProduct.fabric_type === "denim" && (
                        <DenimProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}
                      {(quickViewProduct.fabric_type === "knit" || quickViewProduct.fabric_type === "home_textile") && (
                        <KnitProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}
                      {quickViewProduct.fabric_type === "mix" && (
                        <MixProduct
                          oneProduct={quickViewProduct}
                          editMode={false}
                          setEditMode={() => {}}
                        />
                      )}

                      {!["denim", "knit", "mix"].includes(quickViewProduct.fabric_type) && quickViewProduct.fabric_types && (
                          <>
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "denim" && <DenimProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "knit" && <KnitProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                             {quickViewProduct.fabric_types.name?.toLowerCase() === "mix" && <MixProduct oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                          </>
                      )}
   </div>
                      {folders && folders.folders && folders.folders.length > 0 && (
                      <div  style={{ position: "relative", padding: "20px", background: "#fff", height: "auto", minHeight: "400px" }}>


                          {showCollectionForm ? (
                              <div className="create_collection_form_modern" style={{ 
                                  padding: "24px", 
                               
                                  borderRadius: "16px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px"
                              }}>
                                  <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>
                                  
                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                                      <input
                                          type="text"
                                          placeholder="e.g. Summer 2024"
                                          value={folderData.name}
                                          onChange={(e) => setFolderData({ ...folderData, name: e.target.value })}
                                          style={{ 
                                              border: "1px solid #e2e8f0", 
                                              borderRadius: "8px", 
                                              width: "100%", 
                                              outline: "none", 
                                              fontSize: "14px", 
                                              padding: "10px 14px",
                                              background: "white",
                                              transition: "border-color 0.2s"
                                          }}
                                          onFocus={(e) => e.target.style.borderColor = "#00468c"}
                                          onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
                                      />
                                  </div>

                                  <div style={{ display: "flex", gap: "16px" }}>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                                          <ReactSelect
                                              placeholder="Select Season"
                                              options={options_season}
                                              value={options_season.find(o => o.value === folderData.season)}
                                              onChange={(val: any) => setFolderData({ ...folderData, season: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                                          <ReactSelect
                                              placeholder="Select Year"
                                              options={options_year}
                                              value={options_year.find(o => o.value === folderData.year)}
                                              onChange={(val: any) => setFolderData({ ...folderData, year: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                  </div>

                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                                      <ReactSelect
                                          isMulti
                                          placeholder="Search names..."
                                          options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                                          onChange={(val: any) => setFolderData({ ...folderData, collaborator: val.map((v: any) => v.value) })}
                                          styles={customStylesCreateModern}
                                      />
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "8px" }}>
                                      <button 
                                          className="btn_modern_cancel"
                                          onClick={() => setShowCollectionForm(false)}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "1px solid #e1e8f0",
                                              background: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.background = "#f8fafc"}
                                          onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                      >
                                          Cancel
                                      </button>
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={handleCreateNewFolder}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.opacity = "0.9"}
                                          onMouseOut={(e) => e.currentTarget.style.opacity = "1"}
                                      >
                                          Create
                                      </button>
                                  </div>
                              </div>
                          ) : (
                              <>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                                      <span style={{ fontSize: "14px", fontWeight: 600, color: "#64748b" }}>Choose a collection</span>
                                      <Tooltip title="Create New Collection">
                                          <button
                                              onClick={() => setShowCollectionForm(true)}
                                              style={{ 
                                                  width: "36px", 
                                                  height: "36px", 
                                                  borderRadius: "50%", 
                                                  border: "1px solid #e1e8f0", 
                                                  background: "white",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                  color: "#00468c",
                                                  transition: "all 0.2s"
                                              }}
                                              onMouseOver={(e) => e.currentTarget.style.background = "#f1f5f9"}
                                              onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                          >
                                              <PlusIcon />
                                          </button>
                                      </Tooltip>
                                  </div>

                                  <div className="list_folders" style={{ display: "grid", gridTemplateColumns:"repeat(2,1fr)", gap: "8px", maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                                      {folders.folders &&
                                          folders.folders
                                              .filter((el: any) => el.client_id == user.id)
                                              .map((folder: any) => (
                                                  <Folder
                                                      clickable={true}
                                                      selectOneFolder={true}
                                                      addToCollection={true}
                                                      folder={folder}
                                                      key={folder.id}
                                                  />
                                              ))}
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "20px" }}>
                                  
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={() => {
                                              if (folders.folderIdToMoveTo) {
                                                  dispatch(addProducttoFolder(folders.folderIdToMoveTo, quickViewProduct?.id));
                                                  dispatch(clearfolderToMoveTo());
                                              } else {
                                                  message.error("Please select a collection first");
                                              }
                                          }}
                                          style={{
                                              padding: "8px",
                                              borderRadius: "8px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "13px",
                                              fontWeight: 600,
                                              cursor: "pointer"
                                          }}
                                      >
                                          Confirm
                                      </button>
                                  </div>
                              </>
                          )}


                      </div>)}

                    </div>
                  </div>
               
                  <div style={{ padding: "10px 30px 20px" }}>
                    <Link
                      to={`/product/details/${params.fabric}/${params.genderId}/${params.categoryId}/${quickViewProduct.name}/${quickViewProduct.id}`}
                      className="ant-btn ant-btn-primary ant-btn-block"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "50px",
                        fontSize: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#000",
                        borderColor: "#000",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                      }}
                    >
                      VIEW FULL DETAILS
                    </Link>
                  </div>
                </div>
                )}
            </Drawer>
             <BottomDrawer mode="add_to_collection" />
    </DragDropContext>
  );
};
